<template>
<v-app>
  <v-container>
    <v-row>
      <v-col>
        <v-text-field label="کمیسیون" v-model="thePercent"/>
      </v-col>
      <v-col>
        <v-btn @click="submitCommission">ثبت</v-btn>
      </v-col>
    </v-row>
  </v-container>
</v-app>
</template>

<script>

import Service from '../../../utils/admin-service'

export default {
  name: "commission",
  data(){
    return{
      thePercent:null,
      firstPercent:null
    }
  },
  mounted() {

    this.authService.receive('admin/commission' , {}, (s, d) => {
      if (s == 200) {
        if (d.data !== null){
          this.thePercent = d.data.percent
          this.firstPercent = d.data.percent
        }
      }
    }, (s, e) => {

    })

  },
  computed: {
    authService() {
      return Service(true)
    },
  },
  methods:{
    submitCommission(){
      if (this.firstPercent !== this.thePercent) {
        let f = new FormData()
        f.append('percent', this.thePercent)

        this.authService.transmit('admin/commission/1', f, () => {
          alert(" تغییر داده شد")
        }, (s, er) => {
          console.log({er})
        })
      } else {
        let f = new FormData()
        f.append('percent', this.thePercent)

        this.authService.transmit('admin/commission', f, () => {
          alert(" ثبت شد")
        }, (s, er) => {
          console.log({er})
        })
      }
    }
  }
}
</script>

<style scoped>

</style>